import axios from '@axios'

const state = () => ({
  expenses: {
    meta: {
      pagination: {
        page: 1,
        per_page: 10,
        total_objects: 0,
      },
    },
    data: [],
  },
})

const getters = {
  expenses(state) {
    return state.expenses.data
  },
  expensesTotal(state) {
    return state.expenses.total
  },
  expensesPagination(state) {
    return state.expenses.meta.pagination
  },
}

const mutations = {
  SET_EXPENSES(state, payload) {
    state.expenses = payload
  },
  CHANGE_PAGINATION(state, { field, value }) {
    state.expenses.meta.pagination[field] = value
  },
}

const normalizeExpenseTypeCatalog = value => {
  if (Array.isArray(value)) return value.length ? value : ['null']
  if (value === null || value === undefined || value === '') return ['null']
  return [value]
}

const normalizeExpenseDate = value => {
  if (!value || !Object.keys(value).length) return null
  if (typeof value === 'string') return value
  return JSON.stringify(value)
}

const actions = {
  fetchExpenses(
    context,
    {
      projectId = null,
      customerId = null,
      groupId = null,
      dates,
      supplier,
      name,
      status,
      expensetypecatalog,
      column,
      order,
      pagination = { page: 1, per_page: 10, all: true },
    },
  ) {
    return new Promise((resolve, reject) => {
      const byExpenseDate = normalizeExpenseDate(dates)
      const byExpenseTypeCatalog = normalizeExpenseTypeCatalog(expensetypecatalog)
      let byColumn = null
      if (column) {
        byColumn = JSON.stringify({ order: order || 'ASC', column })
      }

      const params = {
        by_project: projectId,
        by_customer: customerId,
        by_grouped_expense: groupId,
        by_supplier: supplier && supplier.trim ? supplier.trim() : supplier,
        by_name: name && name.trim ? name.trim() : name,
        by_expense_status: status,
        by_expense_date: byExpenseDate,
        by_expense_type_catalog: byExpenseTypeCatalog,
        by_column: byColumn,
        meta: {
          pagination,
        },
      }

      Object.keys(params).forEach(key => {
        if (key === 'meta') return
        if (params[key] === null || params[key] === undefined || params[key] === '') {
          delete params[key]
        }
      })

      axios
        .get('/v1/expenses', {
          params,
        })
        .then(response => {
          context.commit('SET_EXPENSES', response.data)
          resolve(response.data)
        })
        .catch(error => {
          reject(error.response)
        })
    })
  },
  addExpense(context, expense) {
    return new Promise((resolve, reject) => {
      axios
        .post('/v1/expenses', {
          expense,
        })
        .then(response => {
          resolve(response.data)
        })
        .catch(error => {
          reject(error.response)
        })
    })
  },
  updateExpenseStatus(_, { expenseId, status }) {
    return new Promise((resolve, reject) => {
      axios
        .put(`/v1/expenses/${expenseId}`, {
          expense_status: status,
        })
        .then(response => {
          resolve(response.data)
        })
        .catch(error => {
          reject(error.response)
        })
    })
  },
  updateExpense(_, expense) {
    return new Promise((resolve, reject) => {
      axios
        .put(`/v1/expenses/${expense.id}`, {
          expense,
        })
        .then(response => {
          resolve(response.data)
        })
        .catch(error => {
          reject(error.response)
        })
    })
  },
  deleteExpense(_, expenseId) {
    return new Promise((resolve, reject) => {
      axios
        .delete(`/v1/expenses/${expenseId}`)
        .then(response => {
          resolve(response.data)
        })
        .catch(error => {
          reject(error.response)
        })
    })
  },
  fetchSuppliers(_, { projectId, customerId = null, column = null }) {
    return new Promise((resolve, reject) => {
      let byColumn = null
      if (column) {
        byColumn = JSON.stringify({ order: 'ASC', column })
      }
      const params = {
        by_project: projectId,
        by_customer: customerId,
        by_column: byColumn,
      }

      Object.keys(params).forEach(key => {
        if (params[key] === null || params[key] === undefined || params[key] === '') {
          delete params[key]
        }
      })

      axios
        .get('/v1/expenses/supplier_list', {
          params,
        })
        .then(response => {
          resolve(response.data)
        })
        .catch(error => {
          reject(error.response)
        })
    })
  },
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
}
